import React from 'react';
import type { FC } from 'react';
import Lottie from 'lottie-react';

interface CarouselSlideProps {
    animData: Record<string, unknown>;
}

export const CarouselSlide: FC<CarouselSlideProps> = ({ animData }) => {
    return <Lottie animationData={animData} loop={true} autoplay={true} />;
};
